import PropTypes from 'prop-types'
import React, { useState } from 'react'
import i18n from 'simple-react-i18n'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'
import { shallowEqual, useSelector } from 'react-redux'
import UserDto from 'administration/components/user/dto/UserDto'
import { Button, Card, Grid } from '@mui/material'
import MultiContributorsAutocomplete from 'referencial/components/contributor/components/MultiContributorsAutocomplete'
import SuperMultiAutocomplete from 'components/forms/SuperMultiAutocomplete'

const emptyFilter = {
    startDate: null,
    endDate: null,
    users: [],
    contributors: [],
}

const StatsFilterPanel = ({
    onChange = () => { },
}) => {
    const [tmpFilter, setTmpFilter] = useState(emptyFilter)

    const {
        users,
        contributors,
    } = useSelector(store => ({
        users: store.UserReducer.users,
        contributors: store.ContributorReducer.contributors,
    }), shallowEqual)

    const onReset = () => {
        onChange(emptyFilter)
        setTmpFilter(emptyFilter)
    }

    return (
        <Card sx={{ padding: 1 }}>
            <Grid container spacing={1}>
                <Grid container size={12}>
                    <Grid size={3}>
                        <SimpleDatePicker
                            value={tmpFilter.startDate}
                            label={i18n.startDate}
                            onChange={v => setTmpFilter({ ...tmpFilter, startDate: v })}
                            max={tmpFilter.endDate}
                        />
                    </Grid>
                    <Grid size={3}>
                        <SimpleDatePicker
                            value={tmpFilter.endDate}
                            label={i18n.endDate}
                            onChange={v => setTmpFilter({ ...tmpFilter, endDate: v })}
                            min={tmpFilter.startDate}
                        />
                    </Grid>
                    <Grid size={3}>
                        <SuperMultiAutocomplete
                            label={i18n.user}
                            options={users}
                            keyLabel='login'
                            keyValue='login'
                            onChange={values => setTmpFilter({ ...tmpFilter, users: values })}
                            values={tmpFilter.users}
                            multiple
                        />
                    </Grid>
                    <Grid size={3}>
                        <MultiContributorsAutocomplete
                            multiple
                            options={contributors}
                            onChange={values => setTmpFilter({ ...tmpFilter, contributors: values })}
                        />
                    </Grid>
                </Grid>
                <Grid container size={12} justifyContent='flex-end'>
                    <Button variant='outlined' onClick={onReset}>
                        {i18n.reinit}
                    </Button>
                    <Button variant='contained' onClick={() => onChange(tmpFilter)}>
                        {i18n.search}
                    </Button>
                </Grid>
            </Grid>
        </Card>
    )
}
StatsFilterPanel.propTypes = {
    onChange: PropTypes.func,
    users: PropTypes.arrayOf(PropTypes.instanceOf(UserDto)),
}

export default StatsFilterPanel